import { styled } from 'styled-components';
import { IEntireArticleBox1, defaultParams } from './params';
import { IGlobaVariables } from '../../Layout/styles';
import { IContent } from '../../../types/elements';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IEntireArticleBox1;
  $global: IContent;
}>`
  .article-wrapper {
    padding: 25px 20px 40px;
    box-shadow: ${({ $config: style }) => style.group_article.boxShadow};
    background: ${({ $config: style }) => style.group_article.backgroundColor};
    border-radius: ${({ $config: style }) => style.group_article.borderRadius};
    border: ${({ $config: style }) => style.group_article.border};
    h1 {
      padding-bottom: 20px;
      margin-bottom: 0;
    }
    p {
      &:first-of-type {
        font-weight: bold;
        &.article-sponsored {
          font-weight: ${({ $global: style }) => style.text.fontWeight};
        }
      }
    }
    blockquote {
      position: relative;
      z-index: 10;
      font-size: ${({ $global: style }) => style.text.fontSize};
      font-weight: ${({ $global: style }) => style.text.fontWeight};
      line-height: ${({ $global: style }) => style.text.lineHeight};
      font-style: ${({ $config: style }) => style.group_article.group_blockquote.fontStyle};
      color: ${({ $config: style }) => style.group_article.group_blockquote.color};
      margin: 15px 0 20px;
      padding: 26px 28px;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -2;
        border-radius: ${({ $config: style }) => style.group_article.group_blockquote.borderRadius};
        background: ${({ $config: style }) => style.group_article.group_blockquote.backgroundColor};
      }

      &::after {
        content: ${({ $config: style }) =>
          `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='70' width='70' fill='${style.group_article.group_blockquote.group_image.color.replace(
            '#',
            '%23',
          )}' viewBox='0 0 448 512'%3E%3C!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z'/%3E%3C/svg%3E")`};
        position: absolute;
        top: -10px;
        left: -6px;
        z-index: -1;
        color: #fff;
        transform: rotate(-21deg);
      }
    }
  }
`;

export default Styles;
